module.exports = "<div class=\"row\" style=\"width: 400px\">\n  <div class=\"col-sm-12\">\n    <div class=\"input-group\">\n      <input type=\"text\" class=\"form-control\" [(ngModel)]=\"textToCopy\">\n      <span class=\"input-group-btn\">\n        <button class=\"btn btn-default\"  type=\"button\" ngxClipboard\n                [cbContent]=\"textToCopy\" (cbOnSuccess)=\"onCopyDone()\">کپی\n        </button>\n      </span>\n    </div>\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/shared/sharing-form/sharing-form.template.html
// module id = 961
// module chunks = 3